var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { attrs: { id: "drive-public" } },
        [
          _c(
            "b-card",
            {
              staticClass: "h-full",
              attrs: { "header-bg-variant": "primary", "no-body": "" },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function() {
                    return [
                      _c("h4", { staticClass: "mb-0 text-white" }, [
                        _vm._v(_vm._s(_vm.title))
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "footer",
                  fn: function() {
                    return [
                      _c("page-footer", { attrs: { showLoginLink: false } })
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c(
                "div",
                { staticClass: "drive-public-content p-2" },
                [
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "text-center p-4" },
                        [
                          _c("b-spinner", {
                            attrs: { variant: "primary", label: "Loading..." }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.error
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "mb-0",
                          attrs: { show: "", variant: "danger" }
                        },
                        [_vm._v(" " + _vm._s(_vm.error) + " ")]
                      )
                    : _vm._e(),
                  !_vm.loading && !_vm.error
                    ? [
                        _c("file-explorer-component", {
                          attrs: {
                            "drive-public-service": _vm.drivePublicService
                          },
                          on: {
                            "file-open": _vm.handleFileOpen,
                            "download-file": _vm.handleDownloadFile,
                            "show-item-details": _vm.handleShowItemDetails
                          }
                        })
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
          )
        ],
        1
      ),
      _c("file-details-popup", {
        attrs: { item: _vm.selectedItem },
        model: {
          value: _vm.showItemDetails,
          callback: function($$v) {
            _vm.showItemDetails = $$v
          },
          expression: "showItemDetails"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }